export default __webpack_public_path__ + "static/media/tic.d683d314.mp3";